/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, LOSS OF USE, DATA, OR
 *  PROFITS, OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Protection Constants declaration
 * @ignore
 */
export default {
    CLEARKEY_KEYSTEM_STRING: 'org.w3.clearkey',
    CLEARKEY_UUID: 'e2719d58-a985-b3c9-781a-b030af78d30e',
    ENCRYPTION_SCHEME_CBCS: 'cbcs',
    ENCRYPTION_SCHEME_CENC: 'cenc',
    FAIRPLAY_KEYSTEM_STRING: 'com.apple.fps',
    FAIRPLAY_UUID: '94ce86fb-07ff-4f43-adb8-93d2fa968ca2',
    INITIALIZATION_DATA_TYPE_CENC: 'cenc',
    INITIALIZATION_DATA_TYPE_KEYIDS: 'keyids',
    INITIALIZATION_DATA_TYPE_SINF: 'sinf',
    INITIALIZATION_DATA_TYPE_WEBM: 'webm',
    MEDIA_KEY_MESSAGE_TYPES: {
        LICENSE_REQUEST: 'license-request',
        LICENSE_RENEWAL: 'license-renewal',
        LICENSE_RELEASE: 'license-release',
        INDIVIDUALIZATION_REQUEST: 'individualization-request',
    },
    MEDIA_KEY_STATUSES: {
        USABLE: 'usable',
        EXPIRED: 'expired',
        RELEASED: 'released',
        OUTPUT_RESTRICTED: 'output-restricted',
        OUTPUT_DOWNSCALED: 'output-downscaled',
        STATUS_PENDING: 'status-pending',
        INTERNAL_ERROR: 'internal-error',
    },
    PLAYREADY_KEYSTEM_STRING: 'com.microsoft.playready',
    PLAYREADY_RECOMMENDATION_KEYSTEM_STRING: 'com.microsoft.playready.recommendation',
    PLAYREADY_UUID: '9a04f079-9840-4286-ab92-e65be0885f95',
    ROBUSTNESS_STRINGS: {
        WIDEVINE: {
            SW_SECURE_CRYPTO: 'SW_SECURE_CRYPTO',
            SW_SECURE_DECODE: 'SW_SECURE_DECODE',
            HW_SECURE_CRYPTO: 'HW_SECURE_CRYPTO',
            HW_SECURE_DECODE: 'HW_SECURE_DECODE',
            HW_SECURE_ALL: 'HW_SECURE_ALL'
        }
    },
    W3C_CLEARKEY_UUID: '1077efec-c0b2-4d02-ace3-3c1e52e2fb4b',
    WIDEVINE_KEYSTEM_STRING: 'com.widevine.alpha',
    WIDEVINE_UUID: 'edef8ba9-79d6-4ace-a3c8-27dcd51d21ed',
}


